import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "~/components/content/content-item-render";
import type { postiesPrimaryContentItemContent$key } from "~/queries/__generated__/postiesPrimaryContentItemContent.graphql";
import type { CustomQueryParameters } from "~/types/gtm";

import {
  Container,
  Content,
  Headline,
  StyledButton,
  StyledContentCoverImage,
  StyledEntityLink,
  StyledOffsetContainer,
} from "./styles";

export type Props = {
  className?: string;
  customQueryParameters?: CustomQueryParameters;
  provider: DefaultComponentsProvider;
  reference: postiesPrimaryContentItemContent$key;
};

export const ContentItemPostiesPrimary = forwardRef<HTMLDivElement, Props>(
  ({ className, customQueryParameters, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment postiesPrimaryContentItemContent on Content {
          ...entityLink
          ...contentCoverImageContent
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink query={customQueryParameters} reference={content}>
          <StyledOffsetContainer borderRadius="20px">
            <StyledContentCoverImage
              reference={content}
              responsiveVariants={{
                desktopUp: "size1200x800",
                mobileUp: "size540x360",
                tabletUp: "size540x360",
              }}
            />
          </StyledOffsetContainer>
          <Content>
            <Headline>
              {provider.headline({
                hideTag: true,
                preferSocialHeadline: true,
              })}
            </Headline>
            <StyledButton variant="button">READ MORE</StyledButton>
          </Content>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemPostiesPrimary.displayName = "ContentItemPostiesPrimary";
